import { useModel } from "@umijs/max";
import { useCallback, useEffect, useRef, useState } from "react";
import processQueue from "@/utils/processQueue";
import { RcFile } from "antd/es/upload";
import upload from "@/utils/upload";
import { UploadRequestOption } from "@/types";

const useQueueUpload = (concurrencyLimit?: number) => {
  const { obsUploadData } = useModel("useCommonModel");
  const [requestTasks, setRequestTasks] = useState<UploadRequestOption[]>([]);
  /**
   * 记录已上传的文件uid，避免重复上传
   */
  const uploadHistoryRef = useRef<Record<string, boolean>>({});

  const appendTask = useCallback((option: UploadRequestOption) => {
    setRequestTasks((pre) => [...pre, option]);
  }, []);

  useEffect(() => {
    processQueue(
      concurrencyLimit || 3, // 并发数量，应该根据实际场景判断
      requestTasks,
      (option) =>
        new Promise<void>((resolve) => {
          if (uploadHistoryRef.current[(option.file as RcFile).uid]) {
            resolve();
          } else {
            uploadHistoryRef.current[(option.file as RcFile).uid] = true;
            upload(option, obsUploadData, resolve);
          }
        }),
    );
  }, [concurrencyLimit, obsUploadData, requestTasks]);

  return {
    customRequest: appendTask,
  };
};

export default useQueueUpload;
